<template>
  <Input
    class="cxm-InputTimePicker"
    :class="{'cxm-InputTimePicker-disable' : disable}"
    placeholder="hh:mm AM"
    :value="value"
    :disabled="disable"
    readonly
    @click="handle"
  >
    <template #leftIcons>
      <IconComponent
        :handle-click="handle"
        name="Clock"
        color="var(--track-color-bluegray-70)"
      />
    </template>
  </Input>
</template>
<script>
import Input from '../Input/Input.vue';
import IconComponent from '../Icon/Icon.vue';

export default {
  components: { Input, IconComponent },
  props: {
    value: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handle(event) {
      this.$emit('click', event);
    },
  },
};
</script>
<style scoped>
.cxm-InputTimePicker {
  width: 204px;
  cursor: pointer;
  line-height: var(--track-spacing-md);
}

.cxm-InputTimePicker-disable {
  cursor: auto;
}
</style>
